export async function* generateMessageWithDelay(
  message: string,
  baseDelay = 100,
): AsyncGenerator<string> {
  const words = message.split(' ')
  for (const word of words) {
    yield word
    const delay = Math.floor(Math.random() * 100) + baseDelay
    await new Promise<void>((resolve) => setTimeout(resolve, delay))
  }
}
